// PSGRenderer: décor du Parc des Princes et éléments foot


export class PSGBackgroundRenderer {
drawBackground(ctx: CanvasRenderingContext2D, cameraX: number, width: number, height: number) {
	// Fond vert pelouse + gradins
	ctx.fillStyle = '#1e7c2a'; // Vert pelouse
	ctx.fillRect(cameraX, 0, width, height);


	// --- Tifo PSG : bandes verticales rouges et bleues ---
	const tifoStripeWidth = 60;
	const gradinHeight = 200;
	for (let i = 0; i < Math.ceil(width / tifoStripeWidth); i++) {
	ctx.fillStyle = i % 2 === 0 ? '#e30613' : '#0055a4';
	ctx.globalAlpha = 0.18;
	ctx.fillRect(cameraX + i * tifoStripeWidth, 0, tifoStripeWidth, gradinHeight);
	ctx.globalAlpha = 1;
	}

	// Gradins moins hauts
	ctx.fillStyle = '#2d2d2d';
	ctx.globalAlpha = 0.92;
	ctx.fillRect(cameraX, 0, width, gradinHeight);
	ctx.globalAlpha = 1;
	ctx.fillStyle = '#e30613'; // Rouge PSG
	ctx.fillRect(cameraX, gradinHeight, width, 18);
	ctx.fillStyle = '#0055a4'; // Bleu PSG
	ctx.fillRect(cameraX, gradinHeight + 18, width, 18);

	// --- Grand logo PSG stylisé au centre des gradins ---
	const logoX = cameraX + width / 2;
	const logoY = gradinHeight / 2 + 5;
	const logoR = 38;
	ctx.save();
	ctx.globalAlpha = 0.16;
	ctx.beginPath();
	ctx.arc(logoX, logoY, logoR, 0, Math.PI * 2);
	ctx.fillStyle = '#0055a4';
	ctx.fill();
	ctx.lineWidth = 6;
	ctx.strokeStyle = '#e30613';
	ctx.stroke();
	// Tour blanc
	ctx.beginPath();
	ctx.arc(logoX, logoY, logoR - 8, 0, Math.PI * 2);
	ctx.lineWidth = 3;
	ctx.strokeStyle = '#fff';
	ctx.stroke();
	// Tour bleu foncé
	ctx.beginPath();
	ctx.arc(logoX, logoY, logoR - 15, 0, Math.PI * 2);
	ctx.lineWidth = 1.5;
	ctx.strokeStyle = '#222';
	ctx.stroke();
	// Tour Eiffel stylisée
	ctx.beginPath();
	ctx.moveTo(logoX, logoY - 18);
	ctx.lineTo(logoX - 7, logoY + 12);
	ctx.lineTo(logoX + 7, logoY + 12);
	ctx.closePath();
	ctx.lineWidth = 2;
	ctx.strokeStyle = '#fff';
	ctx.stroke();
	// Texte PSG au centre
	ctx.font = 'bold 18px Arial';
	ctx.textAlign = 'center';
	ctx.fillStyle = '#fff';
	ctx.globalAlpha = 0.7;
	ctx.fillText('PSG', logoX, logoY + 7);
	ctx.globalAlpha = 1;
	ctx.restore();

	// --- Texte "PARIS SAINT-GERMAIN" stylisé en haut du stade ---
	ctx.save();
	ctx.font = 'bold 22px Arial';
	ctx.textAlign = 'center';
	ctx.fillStyle = '#fff';
	ctx.shadowColor = '#0055a4';
	ctx.shadowBlur = 6;
	ctx.fillText('PARIS SAINT-GERMAIN', cameraX + width / 2, 32);
	ctx.restore();

	// Deux rangées de supporters, certains avec de vrais drapeaux PSG
	const supporterSpacing = 34;
	const visibleStart = cameraX;
	const supporterCount = Math.ceil(width / supporterSpacing) + 2;
	// Première rangée (plus basse, plus grande)
	const supporterY1 = gradinHeight - 20;
	const bodyY1 = supporterY1 + 12;
	for (let i = 0; i < supporterCount; i++) {
	const x = visibleStart + (i * supporterSpacing);
	// Tête
	ctx.beginPath();
	ctx.arc(x, supporterY1, 16, 0, Math.PI * 2);
	ctx.fillStyle = i % 3 === 0 ? '#FFD700' : (i % 3 === 1 ? '#e30613' : '#0055a4');
	ctx.fill();
	// Corps
	ctx.fillStyle = i % 2 === 0 ? '#fff' : '#222';
	ctx.fillRect(x - 12, bodyY1, 24, 22);
	// Drapeau PSG (vrai, style ballon collectible)
	if (i % 5 === 0) {
		drawBallon(ctx, x + 18, bodyY1 - 10);
	} else if (i % 4 === 0) {
		ctx.beginPath();
		ctx.moveTo(x + 16, bodyY1);
		ctx.lineTo(x + 36, bodyY1 + 4);
		ctx.lineTo(x + 36, bodyY1 + 20);
		ctx.lineTo(x + 16, bodyY1 + 16);
		ctx.closePath();
		const grad = ctx.createLinearGradient(x + 16, bodyY1, x + 36, bodyY1 + 20);
		grad.addColorStop(0, '#0055a4');
		grad.addColorStop(0.5, '#fff');
		grad.addColorStop(1, '#e30613');
		ctx.fillStyle = grad;
		ctx.fill();
		ctx.strokeStyle = '#222';
		ctx.lineWidth = 1.2;
		ctx.stroke();
	}
	}
	// Deuxième rangée (plus haute, plus petite)
	const supporterY2 = gradinHeight - 55;
	const bodyY2 = supporterY2 + 8;
	for (let i = 0; i < supporterCount; i++) {
	const x = visibleStart + (i * supporterSpacing) + (supporterSpacing / 2);
	// Tête
	ctx.beginPath();
	ctx.arc(x, supporterY2, 11, 0, Math.PI * 2);
	ctx.fillStyle = i % 3 === 0 ? '#FFD700' : (i % 3 === 1 ? '#e30613' : '#0055a4');
	ctx.fill();
	// Corps
	ctx.fillStyle = i % 2 === 0 ? '#fff' : '#222';
	ctx.fillRect(x - 7, bodyY2, 14, 14);
	// Drapeau PSG (petit)
	if (i % 6 === 0) {
		drawBallon(ctx, x + 10, bodyY2 - 7);
	} else if (i % 4 === 0) {
		ctx.beginPath();
		ctx.moveTo(x + 10, bodyY2);
		ctx.lineTo(x + 22, bodyY2 + 2);
		ctx.lineTo(x + 22, bodyY2 + 10);
		ctx.lineTo(x + 10, bodyY2 + 8);
		ctx.closePath();
		const grad = ctx.createLinearGradient(x + 10, bodyY2, x + 22, bodyY2 + 10);
		grad.addColorStop(0, '#0055a4');
		grad.addColorStop(0.5, '#fff');
		grad.addColorStop(1, '#e30613');
		ctx.fillStyle = grad;
		ctx.fill();
		ctx.strokeStyle = '#222';
		ctx.lineWidth = 1;
		ctx.stroke();
	}
	}

	// Lignes blanches du terrain
	ctx.strokeStyle = '#fff';
	ctx.lineWidth = 3;
	ctx.beginPath();
	ctx.moveTo(cameraX, height - 40);
	ctx.lineTo(cameraX + width, height - 40);
	ctx.stroke();
}

drawGround(ctx: CanvasRenderingContext2D, cameraX: number, width: number, height: number) {
	// Sol = pelouse
	ctx.fillStyle = '#1e7c2a';
	ctx.fillRect(cameraX, height - 40, width, 40);
	// Lignes blanches
	ctx.strokeStyle = '#fff';
	ctx.lineWidth = 2;
	ctx.beginPath();
	ctx.moveTo(cameraX, height - 40);
	ctx.lineTo(cameraX + width, height - 40);
	ctx.stroke();
}
}

// Obstacle = ballon de foot 
export function drawPSGObstacle(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number) {
	ctx.save();
	const r = Math.min(w, h) / 2;
	const cx = x + w / 2;
	const cy = y + h / 2;
	// Ballon principal
	ctx.beginPath();
	ctx.arc(cx, cy, r, 0, Math.PI * 2);
	ctx.fillStyle = '#fff';
	ctx.shadowColor = '#222';
	ctx.shadowBlur = 8;
	ctx.fill();
	ctx.shadowBlur = 0;
	ctx.strokeStyle = '#222';
	ctx.lineWidth = 2.5;
	ctx.stroke();

	// Motif pentagone central (noir)
	ctx.save();
	ctx.translate(cx, cy);
	ctx.rotate(Math.PI / 5);
	ctx.beginPath();
	for (let i = 0; i < 5; i++) {
		const angle = (Math.PI * 2 * i) / 5;
		ctx.lineTo(Math.cos(angle) * (r * 0.45), Math.sin(angle) * (r * 0.45));
	}
	ctx.closePath();
	ctx.fillStyle = '#222';
	ctx.shadowColor = '#222';
	ctx.shadowBlur = 4;
	ctx.fill();
	ctx.shadowBlur = 0;
	ctx.restore();

// Hexagones autour (gris)
for (let j = 0; j < 5; j++) {
	ctx.save();
	ctx.translate(cx, cy);
	ctx.rotate((Math.PI * 2 * j) / 5);
	ctx.beginPath();
	for (let i = 0; i < 6; i++) {
	const angle = (Math.PI * 2 * i) / 6;
	ctx.lineTo(Math.cos(angle) * (r * 0.7), Math.sin(angle) * (r * 0.7));
	}
	ctx.closePath();
	ctx.strokeStyle = '#bbb';
	ctx.lineWidth = 2;
	ctx.stroke();
	ctx.restore();
}

	// Effet de lumière sur le ballon
	ctx.save();
	ctx.globalAlpha = 0.18;
	ctx.beginPath();
	ctx.arc(cx - r/3, cy - r/3, r/2, 0, Math.PI * 2);
	ctx.fillStyle = '#fff';
	ctx.fill();
	ctx.restore();

	ctx.restore();
}

// Collectible = drapeau PSG
export function drawBallon(ctx: CanvasRenderingContext2D, x: number, y: number) {
	ctx.save();
	// Mât du drapeau
	ctx.beginPath();
	ctx.moveTo(x + 6, y + 24);
	ctx.lineTo(x + 6, y + 4);
	ctx.lineWidth = 3;
	ctx.strokeStyle = '#222';
	ctx.stroke();

	// Drapeau
	ctx.beginPath();
	ctx.moveTo(x + 6, y + 6);
	ctx.lineTo(x + 28, y + 10);
	ctx.lineTo(x + 28, y + 20);
	ctx.lineTo(x + 6, y + 16);
	ctx.closePath();
// Dégradé bleu-rouge PSG
const grad = ctx.createLinearGradient(x + 6, y + 6, x + 28, y + 20);
	grad.addColorStop(0, '#0055a4');
	grad.addColorStop(0.5, '#fff');
	grad.addColorStop(1, '#e30613');
	ctx.fillStyle = grad;
	ctx.fill();
	ctx.strokeStyle = '#222';
	ctx.lineWidth = 2;
	ctx.stroke();

	// Logo PSG simplifié (cercle blanc + tour bleu)
	ctx.beginPath();
	ctx.arc(x + 18, y + 13, 4, 0, Math.PI * 2);
	ctx.fillStyle = '#fff';
	ctx.fill();
	ctx.strokeStyle = '#0055a4';
	ctx.lineWidth = 1.5;
	ctx.stroke();
	ctx.restore();
}
